<template>
  <div class="account main">
    <div class="mt20">
      <span class="title1">客户账单</span>
    </div>
    <section class="account-box mt20">
      <Table border :columns="columns" :data="list">
      </Table>
      <Paging v-bind:page-data="pageData" v-on:setPage="setPage" :selectSize="true" @setSize="chooseSize"></Paging>
    </section>
  </div>
</template>
<script>
  import Paging from "@/components/common/paging";
  export default {
    components: {
      Paging
    },
    data() {
      return {
        statusList: [{ //10-待结算，20-已结算，-10-已作废
          value: 10,
          label: '待付款'
        }, {
          value: 20,
          label: '已付款'
        }, {
          value: '-10',
          label: '已作废'
        }],
        pageData: {
          pageTotal: 0, //总页数
          dataTotal: 0, //总条数
          pageIndex: 1, //当前页数
          pageCount: 11 //页面最多显示几个分页组
        },
        screenData: {
          warehouse_id: '',
          PageNum: 1,
          PageSize: 15
        },
        columns: [{
            title: "账单周期",
            key: "bill_start_date",
            width: 220,
            tooltip: true,
            render: (h, params) => {
              let txt = (params.row.bill_start_date || '-') + ' 至 ' + (params.row.bill_end_date || '-');
              return h("span", txt);
            }
          }, {
            title: "账单数",
            key: "bill_count",
            width: 120,
            tooltip: true,
          },
          {
            title: "结算类型",
            key: "bill_type",
            width: 130,
            render: (h, params) => {
              let bill_type = params.row.bill_type;
              if (bill_type == 10) {
                return h("span", "日结算");
              } else if (bill_type == 20) {
                return h("span", "周结算");
              } else if (bill_type == 30) {
                return h("span", "月结算");
              } else if (bill_type == 40) {
                return h("span", "季度结算");
              } else {
                return h("span", "即时结算");
              }
            }
          },
          {
            title: "金额",
            key: "total_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.total_fee || '0.00'));
            }
          },
          {
            title: "出库费",
            key: "out_bill_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.out_bill_fee || '0.00'));
            }
          },
          {
            title: "仓储费",
            key: "stock_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.stock_fee || '0.00'));
            }
          },
          {
            title: "一件代发费",
            key: "post_fee",
            width: 100,
            tooltip: true,
            render: (h, params) => {
              return h('span', '$ ' + (params.row.post_fee || '0.00'));
            }
          },
          {
            title: "操作",
            key: "im_name",
            render: (h, params) => {
              let doms = [];
              doms.push(h('button', {
                'class': "fc-blue",
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.$router.push({
                      path: '/Finance/Bill?bill_start_date=' + (params.row.bill_start_date || '') +
                        '&bill_end_date=' + (params.row.bill_end_date || '') + '&bill_type=' + params.row
                        .bill_type
                    })
                  }
                }
              }, '查看详情'));
              doms.push(h('button', {
                'class': "fc-blue",
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.exportBills(params.row.warehouse_id, params.row.bill_start_date, params.row.bill_end_date,
                      params.row.bill_type);
                  }
                }
              }, '导出出库费明细'));
              doms.push(h('button', {
                'class': "fc-blue",
                style: {
                  marginRight: '10px'
                },
                on: {
                  click: () => {
                    this.exportStocks(params.row.warehouse_id, params.row.bill_start_date, params.row.bill_end_date,
                      params.row.bill_type);
                  }
                }
              }, '导出仓储费明细'));

              return h("div", doms);
            }
          }
        ],
        list: [],
      };
    },
    methods: {
      setPage(page) {
        this.pageData.pageIndex = page;
        this.screenData.PageNum = page;
        this.getList();
      },
      chooseSize(size) {
        this.pageData.pageSize = this.screenData.PageSize = size;
        let p = Math.ceil(this.pageData.dataTotal / this.pageData.pageSize);
        if (this.pageData.pageIndex > p) {
          this.pageData.pageIndex = this.screenData.PageNum = p;
        }
        this.getList();
      },
      getList() {
        this.$axios.get("/ClientBill/report", {
          params: this.screenData
        }).then(res => {
          this.list = res.data || [];
          this.pageData.pageTotal = res.pageTotal;
          this.pageData.dataTotal = res.totalSize;
        });
      },

      exportBills(warehouse_id, bill_start_date, bill_end_date, bill_type) {
        this.$axios.get("/ClientBill/fee/out/report/export/excel", {
          params: {
            warehouse_id: warehouse_id,
            bill_start_date: bill_start_date,
            bill_end_date: bill_end_date,
            bill_type: bill_type
          }
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      },
      exportStocks(warehouse_id, bill_start_date, bill_end_date, bill_type) {
        this.$axios.get("/ClientBill/fee/stock/report/export/excel", {
          params: {
            warehouse_id: warehouse_id,
            bill_start_date: bill_start_date,
            bill_end_date: bill_end_date,
            bill_type: bill_type
          }
        }).then(res => {
          if (res.success && res.data) {
            let a = document.createElement('a'); //创建一个<a></a>标签
            a.href = res.data; //赋值url
            a.download = res.data; //文件名称
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click(); //点击下载
            a.remove(); //删除标签
            this.$Message.info('下载成功');
          }
        })
      }

    },
    created() {
      this.screenData.warehouse_id = localStorage.getItem('warehouse_id')
      if (this.screenData.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
    }
  };
</script>
<style lang="scss">
  .account-box {
    margin: 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/bill/report.vue